// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__bzY5C","footer__content":"style_footer__content__EbKfl t-16 b-16 t-m-20 b-m-20"};